import { Directive, ElementRef, Input, OnChanges, Renderer2, SecurityContext, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Support-ticket csatolmány betöltése auth-fejléccel (support/images/:file
 * végpontról blobként). A [appFetchSupportImage] a kép fájlnevét kapja.
 */
@Directive({
  selector: '[appFetchSupportImage]'
})
export class FetchSupportImageDirective implements OnChanges {
  @Input() appFetchSupportImage: string | null = null;

  constructor(
    private el: ElementRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {}

  ngOnChanges(_changes: SimpleChanges): void {
    const fileName = this.appFetchSupportImage;
    if (typeof fileName === 'string' && fileName.trim().length > 0) {
      this.fetchImage(fileName);
    }
  }

  private fetchImage(imageFileName: string): void {
    this.http.get(`support/images/${imageFileName}`, { responseType: 'blob' }).subscribe({
      next: (res: Blob) => {
        const url = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res)));
        if (url) {
          this.renderer.setAttribute(this.el.nativeElement, 'src', url);
        }
      },
      error: () => { /* betöltési hiba: a slot üresen marad */ },
    });
  }
}
